<template>
  <div class="room__lightning">
    <h3>{{ $t("lightning") }}</h3>
    <div class="flex box">
      <div class="flex__item">
        {{ $t("illuminance") }}
        <div class="fancy__input">
          <!-- <span class="fancy__input-label fancy__input-item">
          </span>-->
          <input
            type="number"
            v-model.number="lux"
            :placeholder="$t('luxPlaceholder')"
            @change="handleLuxChange"
            @focusin="setSearchType('qty')"
            :class="[
              searchType == 'qty'
                ? 'active fancy__input-input fancy__input-item'
                : 'fancy__input-input fancy__input-item'
            ]"
          />
          <span class="fancy__input-unit fancy__input-item">lux</span>
        </div>
        <div v-if="luxError" class="lux error">{{ $t("luxError") }}</div>
      </div>
      <div class="flex__item line">
        <span>{{ $t("or") }}</span>
      </div>
      <div class="flex__item">
        <div class="fancy__input">
          <!-- <span class="fancy__input-label fancy__input-item">{{
            $t("lightningPower")
          }}</span>-->
          <input
            type="number"
            v-model.number="leuchten"
            :placeholder="$t('amountOf')"
            @change="handleLeuchtenChange"
            @focusin="setSearchType('ill')"
            :class="[
              searchType == 'ill'
                ? 'active fancy__input-input fancy__input-item'
                : 'fancy__input-input fancy__input-item'
            ]"
          />
          <span class="fancy__input-unit fancy__input-item">{{
            $t("lamps")
          }}</span>
        </div>

        <div class="fancy__input">
          <!-- <span class="fancy__input-label fancy__input-item"></span> -->
          <input
            class="fancy__input-input fancy__input-item"
            type="number"
            v-model.number="reihen"
            :placeholder="$t('amountOf')"
            @change="handleRowAndColChange"
          />
          <span class="fancy__input-unit fancy__input-item">{{
            $t("rows")
          }}</span>
        </div>

        <div class="fancy__input">
          <!-- <span class="fancy__input-label fancy__input-item"></span> -->
          <input
            class="fancy__input-input fancy__input-item"
            type="number"
            v-model.number="spalten"
            :placeholder="$t('amountOf')"
            @change="handleRowAndColChange"
          />
          <span class="fancy__input-unit fancy__input-item">{{
            $t("cols")
          }}</span>
        </div>
      </div>
    </div>

    <hr />

    <div v-if="errors" class="room__lightning--errors">
      <h3>{{ $t("roomLightningErrorText") }}</h3>
      <ul>
        <li
          class="error"
          v-for="(error, errorIndex) in errors"
          :key="errorIndex"
        >
          {{ errorIndex }} : {{ error }}
        </li>
      </ul>
    </div>
    <div class="flex align--right">
      <input
        type="button"
        @click="doTheMath"
        :value="$t('calculate')"
        class="btn btn-primary"
      />
    </div>
  </div>
</template>

<script>
import { isNumber } from "util";
import ApiService from "../services/api.service";
//eslint-disable-next-line
import fancyInput from "@/assets/scss/fancy__input.scss";

export default {
  props: {
    initialLux: {
      type: Number,
      default: 19,
      validator: function(value) {
        return isNumber(value) && 0 < value;
      }
    },
    initialLeuchten: {
      type: Number
      // default: 1
    },
    initialReihen: {
      type: Number,
      // default: 1,
      min: 1
    },
    intitialSpalten: {
      type: Number
      // default: 1
    },
    dimensions: {
      type: Object
    }
  },
  methods: {
    validateNumericInput(inputValue, defaultValue) {
      if (inputValue && isNumber(inputValue) && 0 < inputValue) {
        return inputValue;
      } else {
        this.errors.push("Wert muss größer 0 sein"); //how do we access $i18n here?
        return defaultValue;
      }
    },
    handleLuxChange() {
      //do some math to know how many lamps we need for x lux
      //v-model handles this data
    },
    handleRowAndColChange() {
      if (this.reihen && this.spalten) {
        this.leuchten = this.reihen * this.spalten;
        this.setSearchType("ill");
      }
    },
    handleLeuchtenChange() {
      // let luxValue = this.leuchten * this.initialLux;
      // console.log(
      //   "handleLeuchtenChange() called.",
      //   this.leuchten,
      //   luxValue,
      //   Math.floor(luxValue),
      //   Math.ceil(luxValue),
      //   Math.round(luxValue),
      //   this.reihen,
      //   this.spalten
      // );
      // this.lux = luxValue;
    },
    doTheMath() {
      this.clearErrors();
      this.$emit("clear-result");
      this.$store.dispatch("showLoadingScreen");
      console.log(
        "doTheMath() called. Sending data to the api and awaiting the answer.",
        this.leuchten,
        this.dimensions,
        this.lux
      );
      let urlParams = "?calc_type=" + encodeURIComponent(this.searchType); //first param

      urlParams +=
        "&search_key=" +
        encodeURIComponent(this.$store.getters.getArticleNumber);
      urlParams +=
        "&room_length=" + encodeURIComponent(this.dimensions.roomlength);
      urlParams += "&room_height=" + encodeURIComponent(this.dimensions.height);
      urlParams += "&room_width=" + encodeURIComponent(this.dimensions.width);
      //qty only if
      if (this.searchType == "ill") {
        urlParams += "&qty=" + encodeURIComponent(this.leuchten);
      } else {
        urlParams += "&required_lux=" + encodeURIComponent(this.lux);
      }
      let selectedRoom = this.$store.getters.getSelectedRoom;
      if (-1 !== Object.keys(selectedRoom).indexOf("id")) {
        if (selectedRoom.params) {
          Object.keys(selectedRoom.params).forEach(elem => {
            //glue those params to the urlParams too
            let urlParam = "&";
            urlParam +=
              encodeURIComponent(elem) +
              "=" +
              encodeURIComponent(selectedRoom.params[elem]);
            urlParams += urlParam;
          });
        }
      }

      ApiService.get(urlParams).then(response => {
        console.log("What did the API respond?:", response);
        if (response.status == 200 && response.data.status == "success") {
          this.handleApiResponse(response.data.data);
        } else {
          this.handleApiError(response.data.errors);
        }
      });
    },
    handleApiResponse(responseData) {
      console.log("handleApiResponse:", responseData);
      this.leuchten = responseData.count;
      this.lux = responseData.lux;

      this.$store.dispatch("hideLoadingScreen");

      this.$emit("render-result", {
        pdf: responseData.url, //"random.pdf",
        leuchten: responseData.count, //this.leuchten,
        lux: responseData.lux
      });
    },
    handleApiError(responseError) {
      console.log("handleApiError:", responseError);

      this.errors = responseError.apiErrors
        ? responseError.apiErrors[0]
        : responseError;

      this.$store.dispatch("hideLoadingScreen");
    },
    clearErrors() {
      this.errors = null;
    },
    fireLightningChange() {
      this.$emit("lighting-change", {
        reihen: this.reihen,
        spalten: this.spalten,
        leuchten: this.leuchten
      });
    },
    getBestFactorForX(x) {
      var factor = 1;
      var factors = [];
      // console.log("getBestFactorForX() factor in Range?", factor <= x);

      if (x <= 0) return factor;

      while (factor <= x) {
        let result = x / factor;
        if (result === parseInt(result)) {
          //even
          factors.push(factor);
        }
        factor++;
      }

      if (factors.length) {
        let middleIndex = Math.ceil(factors.length / 2);
        let bestFactor = factors[middleIndex - 1];

        let result = {
          reihen: bestFactor,
          spalten: x / bestFactor
        };
        return result;
      } else {
        //some error occurred, there must be at least one factor: 1 (!)
        console.error(
          "getBestFactorForX(): No valid factor found, which should not be possible.",
          x
        );
        return 1;
      }
    },
    setSearchType(type) {
      const allowedTypes = ["ill", "qty"];
      if (-1 !== allowedTypes.indexOf(type)) {
        if (
          (allowedTypes[0] == type && this.leuchten) ||
          (allowedTypes[1] == type && this.lux)
        ) {
          this.searchType = type;
        } else {
          console.warn(
            "cannot set search type, probably invalid values?",
            this.lux,
            this.leuchten,
            type
          );
        }
      } else {
        console.error(
          "setSearchType: '" +
            type +
            "' is not allowed as searchType, use one of these: " +
            allowedTypes.join(",")
        );
      }
    }
  },
  watch: {
    //eslint-disable-next-line
    leuchten(newLeuchtenValue, oldLeuchtenValue) {
      // console.log(
      //   "Watch for Leuchten fired: ",
      //   oldLeuchtenValue,
      //   newLeuchtenValue,
      //   this.leuchten
      // );

      let newRowsAndCols = this.getBestFactorForX(this.leuchten);
      this.reihen = newRowsAndCols.reihen;
      this.spalten = newRowsAndCols.spalten;

      this.fireLightningChange();
    },
    lux(newValue, oldValue) {
      if (newValue < 1) {
        this.luxError = true;
        if (oldValue > 0) {
          window.setTimeout(() => {
            this.lux = oldValue;
          }, 1000);
        } else {
          // this.height = this.defaultHeight;
        }
      } else {
        this.luxError = false;
      }
    }
  },
  data() {
    return {
      leuchten: this.initialLeuchten,
      reihen: this.initialReihen,
      spalten: this.intitialSpalten,
      lux: this.initialLux,
      luxError: false,
      errors: null,
      apiCallCounter: 0,
      searchType: "qty" //as default, maybe changed by focus of input fields to qty or ill. Requires to be default, because if roomType gets changed it must otherwise set the search type
    };
  },
  computed: {
    getWidthToLengthFactor() {
      console.log("getWidthToLengthFactor() called", this.dimensions);
      return this.dimensions.width && this.dimensions.roomlength
        ? this.dimensions.width / this.dimensions.roomlength
        : 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/include-media.scss";
@import "@/assets/scss/_variables.scss";
.room__lightning {
  &.isready {
    opacity: 1;
    pointer-events: all;
    transition: all 0.4s;
  }
  &.notready {
    opacity: 0.5;
    transition: all 0.4s;
    pointer-events: none;
  }
  @include media("<desktop-l") {
    hr {
      display: none;
    }
  }
  .btn{
      font-weight: normal;
      font-size: 18px;
      // text-transform: uppercase;
      padding: 5px 30px;
      transition: color 0.3s ease-in-out, background 0.3s ease-in-out, border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
      white-space: normal;
    &.btn-primary{      
      color: #fff;
      background-color: #000;
      border-color: #000;
      &:hover{ 
        background: #fff;
        color: #000;
        border-color: #000;
      }
    }
  }
  .flex {
    display: flex;
    // justify-content: space-between;
    @include media("<desktop-l") {
      flex-direction: column-reverse;
    }
    &__item {
      width: calc(50% - 40px);
      @include media("<desktop-l") {
        width: 100%;
      }
      &.line {
        width: 80px;
        background: linear-gradient(
          to right,
          transparent 48%,
          black 48%,
          black 52%,
          transparent 52%
        );
        @include media("<desktop-l") {
          width: 100%;

          background: linear-gradient(
            to bottom,
            transparent 48%,
            black 48%,
            black 52%,
            transparent 52%
          );
          span {
            padding: 1em;
          }
        }
        align-items: center;
        justify-content: center;
        display: flex;
        span {
          background-color: white;
        }
      }
    }
    &.align {
      &--right {
        justify-content: flex-end;
      }
    }
  }

  .fancy {
    &__input {
      width: 100%;
      &-input {
        width: 50%;
      }
      &-unit {
        width: 20%;
      }
    }
  }

  input {
    max-width: 100%;
    &.active {
      // background-color: rgb(196, 196, 196);
      background-color: black;
      color: white;
    }
  }
  &--errors {
    color: red;
  }
}
</style>
